import * as React from "react";
const Component = props => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M0 16C0 7.16 7.163 0 16 0s16 7.16 16 16-7.163 16-16 16S0 24.84 0 16" opacity={0.1} />
      <path d="M21.5 9h-11C9.12 9 8 10.12 8 11.5v11c0 1.38 1.12 2.5 2.5 2.5h5.5v-7h-2v-2.5h2v-1.5c0-2.21 1.34-3.5 3.5-3.5h2v2.5h-1.5c-.83 0-1 .42-1 1v1.5h2.5L21 16.5h-2V25h2.5c1.38 0 2.5-1.12 2.5-2.5v-11C24 10.12 22.88 9 21.5 9z" />
    </g>
  </svg>
);
export default Component;